import React, { useState, useEffect, useRef } from "react";
import { logo } from '../../assets/svg/svg'
import { Link2 } from 'lucide-react';
import ReactQuill from 'react-quill';
import { SENDER_COPY_SENTINEL, saveSenderEncryptedEmail, sendEmails } from "../../helper/emailHelper";
import Cookies from "universal-cookie";
import Contact from "./Contacts.js";
import { CompleteLoader } from "../../modals/common-alert";
import { useDispatch, useSelector } from "react-redux";
import config from "../../web3/web3Config.json";
import { listOutbox, readOrganizationDataStrict, saveDraft } from '../../db/at-rest.js';
import { clearComposeBuffer } from '../../helper/composeBuffer.js';
import { sendAttachment } from '../../service/api-actions';
import { toast, Bounce } from 'react-toastify';
import Swal from 'sweetalert2'
import { getGeneralSettings, getSendAsEmails, getSingnature } from '../../helper/settingsHelper.js';
import { getSuggestion } from '../../helper/contract-helper.js';
import { Calendar as CalendarIcon } from "lucide-react";
import { Tooltip } from "antd";
import { Signature } from '../../modals/SignatureModal.js';
import Web3 from 'web3'; // for account fetching
import "../../../src/assets/css/calendar.css";
import { logout } from "../../authMiddleware.js";
import { reportError, toErrorString } from "../../utils/errorLogger.js";

const cookies = new Cookies();
const userName = localStorage.getItem('UserName');
const editorConstant = {
  toolBar: [
    [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
    [{ 'size': [] }],
    ['bold', 'italic', 'underline'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }]
  ],
  format: [
    'header', 'font', 'size',
    'bold', 'italic', 'underline',
    'list', 'bullet', 'indent'
  ],
  "emoji-toolbar": true,
  "emoji-textarea": true,
  "emoji-shortname": true
}

function parseCustomDate(str) {
  const match = str.match(/^([0-9]{4})([0-9]{2})([0-9]{2})T([0-9]{2})([0-9]{2})([0-9]{2})$/);
  if (!match) return null;
  const [_, year, month, day, hour, minute, second] = match;
  return new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second)
  );
}

function getGMTOffsetString(date) {
  const offset = -date.getTimezoneOffset(); // in minutes
  const sign = offset >= 0 ? '+' : '-';
  const absOffset = Math.abs(offset);
  const hours = String(Math.floor(absOffset / 60)).padStart(2, '0');
  const minutes = String(absOffset % 60).padStart(2, '0');
  return `GMT${sign}${hours}:${minutes}`;
}

function getFriendlyTimeZoneName(date, tz) {
  try {
    if (tz && tz !== 'system') {
      const dtf = new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'long' });
      const parts = dtf.formatToParts(date);
      const name = parts.find(p => p.type === 'timeZoneName')?.value;
      return name ? `${name} - ${tz.split('/').pop().replace('_', ' ')}` : tz;
    } else {
      const sysTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const dtf = new Intl.DateTimeFormat('en-US', { timeZone: sysTz, timeZoneName: 'long' });
      const parts = dtf.formatToParts(date);
      const name = parts.find(p => p.type === 'timeZoneName')?.value;
      return name ? `${name} - ${sysTz.split('/').pop().replace('_', ' ')}` : sysTz;
    }
  } catch {
    return tz || 'Local Time';
  }
}

function formatEventTime(start, end, timezone) {
  const startDate = parseCustomDate(start);
  const endDate = parseCustomDate(end);
  if (!startDate || !endDate) return 'Invalid date';
  const options = {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: 'numeric', minute: '2-digit', hour12: true
  };
  const startStr = startDate.toLocaleString('en-US', options);
  const endStr = endDate.toLocaleString('en-US', options);
  const gmt = getGMTOffsetString(startDate);
  const tzName = getFriendlyTimeZoneName(startDate, timezone);
  return `${startStr} – ${endStr}<br/>(${gmt}) ${tzName}`;
}

const ComposeEmail = (props) => {
  const savedRange = useRef(null);
  const [user] = useState(cookies.get("userObject"));
  const [accountSettings, setAccountSettings] = useState([]);
  const toemailId = useRef()
  const ccemailId = useRef()
  const bccemailId = useRef()
  const [sendLoader, setSendLoader] = useState(false);
  const [text, setText] = useState("")
  const [isCC, setIsCC] = useState(false);
  const [isBCC, setIsBCC] = useState(false);
  const [emailId, setEmailId] = useState("");
  const [emailCC, setEmailCC] = useState("");
  const [emailBCC, setEmailBCC] = useState("");
  const itemRefs = useRef([]);
  const [receiverName, setReceiverName] = useState(localStorage.getItem("recipient") || '');
  const [CC, setCC] = useState(localStorage.getItem("cc") || '');
  const [BCC, setBCC] = useState(localStorage.getItem("bcc") || '');
  const [subject, setSubject] = useState(localStorage.getItem("topic") || '');
  const [isSpellCheck, setIsSpellCheck] = useState('false');
  const [defaultCC, setDefaultCC] = useState('');
  // True when this user HAS an organization row that could not be opened, so we do not know whether an
  // admin-copy CC is mandated. Distinct from "no org" (defaultCC stays '' and sending is fine) — see
  // fetchReceiverData and the send guard in composeEmail().
  const [orgCCUnavailable, setOrgCCUnavailable] = useState(false);
  const [tooltipText] = useState("Send a copy of the email to the admin user email.");
  const [contact, setContact] = useState(false)
  const dispatch = useDispatch();
  const [recipienttype, setRecipientType] = useState("")
  const draftData = useSelector((state) => state.draftData);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const isMinimize = useSelector((state) => state.composeMin);
  const [suggestions, setSuggestions] = useState([]);
  const [inputType, setInputType] = useState('');
  const [emailSuggestions, setEmailSuggestions] = useState([]);
  const [ctrlA, setCtrlA] = useState(false);
  const [ctrlCC, setCtrlCC] = useState(false)
  const [ctrlBCC, setCtrlBCC] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [link, setLink] = useState('');
  const contactRef = useRef();
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const [tosuggestion, setToSuggestion] = useState(false)
  const [ccsuggestion, setCCSuggestion] = useState(false)
  const [bccsuggestion, setBCCSuggestion] = useState(false)
  const [editorlength, seteditorlength] = useState(0)
  const [isFocused, setIsFocused] = useState({
    receiver: false,
    cc: false,
    bcc: false
  });

  const [sendAsEmail, setSendAsEmail] = useState([]);
  const [fromAddress, setFromAddress] = useState(user?.name);
  const receiverRef = useRef(null);
  const ccRef = useRef(null);
  const bccRef = useRef(null);
  const suggestionListRef = useRef(null);
  const topicRef = useRef(null)
  const [signature, setSignature] = useState("");
  const [isSignatureHtml, setIsSignatureHtml] = useState(false);
  const [linkDisplay, setLinkDisplay] = useState('');
  const [linkUrl, setLinkUrl] = useState('');
  useEffect(() => {
    if (
      highlightedIndex >= 0 &&
      itemRefs.current[highlightedIndex]
    ) {
      itemRefs.current[highlightedIndex]?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [highlightedIndex]);

  useEffect(() => {
    setReceiverName(localStorage.getItem("recipient") || '');
    setSubject(localStorage.getItem("topic") || '')
    setCC(localStorage.getItem("cc") || '');
    setBCC(localStorage.getItem("bcc") || '');
    if (CC) {
      setIsCC(true)
    }
    if (BCC) {
      setIsBCC(true)
    }
    localStorage.getItem("sendingEmail")

  }, [props]);


  useEffect(() => {
    setSettingsJson()
  }, [isMinimize])

  async function setSettingsJson() {
    const filteredAddressBook = await getSuggestion();
    setEmailSuggestions(filteredAddressBook);
    try {
      const generalSettings = await getGeneralSettings();
      setAccountSettings(generalSettings);
    } catch (error) {
      const errorStr = toErrorString(error || error.message);
      reportError({
        endpoint: '-',
        message: `FileName: ComposeEmail.js, Fun: setSettingsJson, ${String(error.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      const sendAsEmail = await getSendAsEmails();
      if (sendAsEmail?.length) {
        sendAsEmail.unshift({
          email: user.name,
          isDefault: true
        });
        const displayEmail = sendAsEmail?.find(email => email.isDefault === 'true')?.email;
        sendAsEmail?.forEach(email => {
          email.isDefault = email.email === displayEmail ? 'true' : 'false';
        });
        if (!displayEmail) {
          sendAsEmail.forEach(email => {
            email.isDefault = email.email === user.name ? 'true' : 'false';
          });
          setFromAddress(user.name);
        } else {
          setFromAddress(displayEmail)
        }
      }
      setSendAsEmail(sendAsEmail);
    }
    fetchData();
  }, [props])

  useEffect(() => {
    const fetchSignature = async () => {
      try {
        const signatureData = await getSingnature();
        if (signatureData && signatureData.signature) {
          setSignature(signatureData.signature);
          setIsSignatureHtml(signatureData.isHtml);
        } else {
          setSignature("");
          setIsSignatureHtml(false);
        }
      } catch (err) {
        const errorStr = toErrorString(err || err.message);
        reportError({
          endpoint: '-',
          message: `FileName: ComposeEmail.js, Fun: handleKeyDown, ${String(err.message || 'Unhandled error')}`,
          error: errorStr,
          userName: userName || '',
        });
        setSignature("");
        setIsSignatureHtml(false);
      }
    };
    fetchSignature();
  }, []);

  useEffect(() => {
    const handleNewEvent = (e) => {
      const details = e.detail;
      const eventHtml = `
            <b>${details.title}</b>
            <p>${formatEventTime(details.start, details.end, details.timezone)}</p>`;
      const prev = localStorage.getItem("sendingEmail") || "";
      localStorage.setItem("sendingEmail", eventHtml + prev);
      setText(eventHtml + prev);
    };
    window.addEventListener("NEW_EVENT_CREATED", handleNewEvent);
    return () => window.removeEventListener("NEW_EVENT_CREATED", handleNewEvent);
  }, []);

  const handleClickOutside = () => {
    setCtrlA(false)
    setCtrlCC(false)
    setCtrlBCC(false)
  }
  useEffect(() => {
    document.addEventListener("click", handleClickOutside)
    return (() => {
      document.removeEventListener("click", handleClickOutside)
    })

  }, [])
  const handleInsertLink = (event) => {
    if (contactRef.current && !contactRef.current.contains(event.target)) {
      if (isPopupVisible) {
        setIsPopupVisible(false)
      }
    }
  }
  useEffect(() => {
    document.addEventListener("click", handleInsertLink)
    return (() => {
      document.removeEventListener("click", handleInsertLink)
    })

  }, [])
  const useHandleSuggestion = (ref, setSuggestion, setEmailValue, value, index, setValue) => {
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          setSuggestion(false);
          const trimmedValue = value.trim();
          const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!emailRegex.test(trimmedValue)) return;
          setEmailValue((prev) => {
            const emails = [...prev.split(',').map(e => e.trim()).filter(Boolean), trimmedValue];
            const uniqueEmails = [...new Set(emails)];
            return uniqueEmails.join(', ');
          });
          setValue("");
        }
      };


      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }, [ref, setSuggestion, setEmailValue, value, index]);
  };

  useHandleSuggestion(toemailId, setToSuggestion, setReceiverName, emailId, highlightedIndex, setEmailId);
  useHandleSuggestion(ccemailId, setCCSuggestion, setCC, emailCC, highlightedIndex, setEmailCC);
  useHandleSuggestion(bccemailId, setBCCSuggestion, setBCC, emailBCC, highlightedIndex, setEmailBCC);

  async function composeEmail(receiver) {
    // Fail closed: the organization row exists but could not be opened, so `defaultCC` below is not
    // trustworthy — an empty string here means "unknown", not "no CC required". Refuse rather than send a
    // mail that may be silently missing the copy recipient the organization mandates.
    if (orgCCUnavailable) {
      toast.error("Can't send: your organization's mail settings are unavailable, so the required copy recipient can't be applied. Please sign in again and retry.", {
        position: "top-center",
        transition: Bounce,
      });
      setSendLoader(false);
      return;
    }
    const generalSettings = await getGeneralSettings();
    const isSavedOn = generalSettings.isSaveSent;
    const recipient = receiver;
    const subject = document.getElementById("subject").value;
    const bcc = isBCC ? BCC : "";
    // Join with a comma — this used to be `cc += defaultCC`, which glued the addresses together
    // ("user@x.com" + "admin@y.com" = "user@x.comadmin@y.com"). Downstream splits cc on "," and
    // validates each address, so the fused string failed validation and BLOCKED the send: any org
    // user with a mandated CC who also typed their own CC could never send. filter(Boolean) keeps
    // the empty cases ("" + defaultCC, or cc + "") producing a clean single address.
    let cc = [isCC ? CC : "", defaultCC].filter(Boolean).join(",");


    let isReceipientAdded = false;
    if (recipient || cc || bcc) isReceipientAdded = true;

    if (!isReceipientAdded) {
      toast.error("Please specify at least one recipient.", {
        position: "top-center",
        transition: Bounce,
      });

      setSendLoader(false);
      return;
    }

    if (!subject || !localStorage.getItem("sendingEmail")) {
      Swal.fire({
        text: `${(!subject && !localStorage.getItem("sendingEmail") && "Send this message without a subject or text in the body?") || (!subject && "Send this message without a subject?") || (!localStorage.getItem("sendingEmail") && "Send this message without a text in the body?")}  `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1677ff",
        cancelButtonColor: "#7f7f7f",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        customClass: "compose-sweet-alert"
      }).then(async (result) => {
        if (result.isConfirmed) {
          dispatch({ type: "DRAFT", payload: null });

          // NOT a fallback body — a request asking sendEmails to seal the Sent copy itself, which it
          // recognises by comparing against this exact value. It is never written on chain: emailHelper
          // refuses to archive a placeholder as ciphertext, because one fixed string reaching
          // storeSendMail's `_encryptedData` is claimed globally and permanently by the contract and
          // breaks the Sent copy for every account afterwards. Do not uniquify it per send — that would
          // only stop the comparison matching, and the Sent copy would quietly stop being sealed.
          let defaultEncryptedMessage = SENDER_COPY_SENTINEL;
          /* Sender encryption logic moved to sendEmails for optimization
          if (isSavedOn) {
            const emailObject = { recipient: recipient, subject: subject, message: localStorage.getItem("sendingEmail") };
            if (selectedFiles && selectedFiles.length) {
              const attachmentResult = await sendAttachment(selectedFiles, user.publicKey);
              emailObject.attachment = attachmentResult.returnValue;
            }
            const walletAddress = localStorage.getItem("walletAddress");
            if (!walletAddress) {
              toast.error("Please Connect Your NCOG Wallet", {
                toastId: "errorToast",
                position: "top-center",
                transition: Bounce,
              });
              logout();
              return;
            }
            defaultEncryptedMessage = await saveSenderEncryptedEmail(emailObject, walletAddress);
          }
          */
          const result = await sendEmails(recipient.replace(/\s/g, '').split(","), cc.replace(/\s/g, '').split(","), bcc.replace(/\s/g, '').split(","), subject, localStorage.getItem("sendingEmail"), isSavedOn, defaultEncryptedMessage, selectedFiles, null, null, fromAddress);
          setSendLoader(false);
          setText("")
          if (result) {
            const notifyMessage = `Message Sent`;
            toast.info(notifyMessage, {
              position: "top-center",
              transition: Bounce,
            })
            // The mail is sent: drop the whole cleartext scratch buffer, not just the body — the
            // recipients and subject sat next to it in localStorage just as readably.
            clearComposeBuffer();
            dispatch({ type: "IS_COMPOSE", payload: false })
            props.setIsCompose(false);
            if (props.reRender) props.reRender();
          } else {
            // A falsy result means the on-chain write never landed. Without this the
            // loader just disappears and the user is told nothing. Keep the compose
            // window open so the draft isn't lost.
            // toastId is shared with the attachment-failure toast raised inside sendEmails: when a send
            // fails because an attachment could not be uploaded, that more specific message is already on
            // screen and this generic one must not replace or double up on it.
            toast.error("Message not sent — the blockchain transaction failed. Your draft is still here; please try again.", {
              toastId: "sendFailure",
              position: "top-center",
              transition: Bounce,
            });
          }
        } else {
          setSendLoader(false);
          setText("")
          return true;
        }
      });
    } else {
      dispatch({ type: "DRAFT", payload: null });

      // Same sentinel as the confirm-dialog branch above, and for the same reason — see the comment there.
      let defaultEncryptedMessage = SENDER_COPY_SENTINEL;
      /* Sender encryption logic moved to sendEmails for optimization
      if (isSavedOn) {
        const emailObject = { recipient: recipient, subject: subject, message: localStorage.getItem("sendingEmail") };
        if (selectedFiles && selectedFiles.length) {
          const attachmentResult = await sendAttachment(selectedFiles, user.publicKey);
          emailObject.attachment = attachmentResult.returnValue;
        }
        const walletAddress = localStorage.getItem("walletAddress");
        if (!walletAddress) {
          toast.error("Please Connect Your NCOG Wallet", {
            toastId: "errorToast",
            position: "top-center",
            transition: Bounce,
          });
          logout();
          return;
        }
        defaultEncryptedMessage = await saveSenderEncryptedEmail(emailObject, walletAddress);
      }
      */
      const result = await sendEmails(recipient.replace(/\s/g, '').split(","), cc.replace(/\s/g, '').split(","), bcc.replace(/\s/g, '').split(","), subject, localStorage.getItem("sendingEmail"), isSavedOn, defaultEncryptedMessage, selectedFiles, null, null, fromAddress);
      if (result) {
        const notifyMessage = `Message Sent`;
        toast.info(notifyMessage, {
          position: "top-center",
          transition: Bounce,
        })
      }
      setSendLoader(false);
      setText("")
      if (result) {
        // Sent — see above: the whole buffer goes, body and addressing alike.
        clearComposeBuffer();
        dispatch({ type: "IS_COMPOSE", payload: false })
        props.setIsCompose(false);
        if (props.reRender) props.reRender();
      } else {
        // See above: a falsy result is a failed chain write, not a silent success. Shared toastId, same
        // reason as above — an attachment-upload failure has already shown a more specific message.
        toast.error("Message not sent — the blockchain transaction failed. Your draft is still here; please try again.", {
          toastId: "sendFailure",
          position: "top-center",
          transition: Bounce,
        });
      }
    }
  }

  async function saveDraftFunction() {
    const draftJSON = JSON.parse(draftData);
    const draft = {
      type: "draft",
      to: receiverName,
      bcc: isBCC ? BCC : "",
      cc: isCC ? CC : "",
      subject: subject || "(No Subject)",
      message: localStorage.getItem("sendingEmail"),
      sender: user.name,
    }
    // Sealed under the dMail DEK at rest (db/at-rest.js) — a draft is the user's own plaintext body and
    // used to sit readable on disk. saveDraft returns null when it could not be stored ENCRYPTED; it never
    // downgrades to plaintext, so tell the user rather than let them believe the draft was kept.
    const value = await saveDraft(draftJSON?.id, draft);
    if (!value) {
      toast.error("Draft not saved — your mailbox key is unavailable. Please sign in again.", {
        position: "top-center",
        transition: Bounce,
      });
    }
    return value;
  }
  useEffect(() => {
    setSettingsJson();
  }, []);

  //outBox
  const outBoxIndex = useSelector((state) => state.outBoxIndex);
  useEffect(() => {
    const fetchReceiverData = async () => {
      // The admin-copy CC is an ORGANIZATION-MANDATED restriction, so resolving it must fail CLOSED.
      //
      // readOrganizationData() returns null for BOTH "this user has no organization" and "there is an org
      // row but the DEK could not open it". The `if (organizationData)` below then simply skips
      // setDefaultCC, so the second case silently dropped the mandated CC and the mail still went out —
      // the admin copy the organization requires just quietly not sent, with nobody told. Strict tells the
      // two apart: null = genuinely unaffiliated, throw = there IS an org we cannot read.
      let organizationData = null;
      try {
        organizationData = await readOrganizationDataStrict();
        setOrgCCUnavailable(false);
      } catch (error) {
        // We cannot know whether a CC is mandated, so we must not guess. Flag it, tell the user, and let
        // the send guard in composeEmail() refuse rather than send a possibly non-compliant mail.
        setOrgCCUnavailable(true);
        const errorStr = toErrorString(error || error.message);
        reportError({
          endpoint: '-',
          message: `FileName: ComposeEmail.js, Fun: fetchReceiverData, ${String(error.message || 'Unhandled error')}`,
          error: errorStr,
          userName: userName || '',
        });
        toast.error("Your organization's mail settings couldn't be read, so a required copy recipient can't be applied. Please sign in again before sending.", {
          position: "top-center",
          transition: Bounce,
        });
      }
      if (outBoxIndex !== null) {
        // outBoxIndex is a position in the list Outbox.js rendered, so it must be resolved against the
        // same owner-filtered, decrypted ordering — see at-rest.listOutbox().
        const indexdb = await listOutbox();
        const entry = indexdb[outBoxIndex]?.json;
        if (entry) {
          setReceiverName(entry.to);
          document.getElementById("subject").value = entry.subject;
          if (entry.cc?.length && entry.cc.join(',')) {
            setIsCC(true);
            setCC(entry.cc.join(','));
          }
          if (entry.bcc?.length && entry.bcc.join(',')) {
            setIsBCC(true);
            setBCC(entry.bcc.join(','));
          }
          localStorage.setItem("sendingEmail", entry.message);
        }
        dispatch({ type: "OUTBOX", payload: null, value: false });
      }

      if (organizationData) {
        const { organizationSettings, primaryEmail } = organizationData?.organizationData || {};
        const { sendCopyEmail: userSendCopyEmail, copyEmailUser: userCopyEmail } = organizationData?.userSettingsData || {};
        const { sendCopyEmail: orgSendCopyEmail, copyEmailUser: orgCopyEmail } = organizationSettings || {};
        if (userSendCopyEmail && userCopyEmail) {
          setDefaultCC(userCopyEmail);
        } else if (orgSendCopyEmail && orgCopyEmail) {
          setDefaultCC(orgCopyEmail);
        } else if (orgSendCopyEmail) {
          setDefaultCC(primaryEmail);
        }
      }
    };
    fetchReceiverData();
  }, [outBoxIndex]);


  const LinkPopup = ({ isVisible, onInsert, onCancel, anchorRef }) => {
    const [linkDisplay, setLinkDisplay] = useState("");
    const [linkUrl, setLinkUrl] = useState("");
    const displayInputRef = useRef(null);
    const urlInputRef = useRef(null);

    useEffect(() => {
      if (isVisible) {
        displayInputRef.current?.focus();
      }
    }, [isVisible]);

    if (!isVisible) return null;

    const isInsertEnabled = linkDisplay.trim() !== "" && linkUrl.trim() !== "";

    return (
      <div
        className={`text-editor position-absolute top-neg-168 start-neg-95 p-10px bg-white border border-ccc rounded-5px shadow-custom min-w-420px z-1000 compose-email ${isVisible ? 'visible' : ''}`}
        ref={anchorRef}
      >
        <input
          type="text"
          value={linkDisplay}
          onChange={e => setLinkDisplay(e.target.value)}
          placeholder="Display as"
          ref={displayInputRef}
          className="mb-10px p-5px w-100 border rounded-5px border-bottom-ccc"
          onKeyDown={e => {
            if (e.key === 'Enter') {
              urlInputRef.current?.focus();
            }
          }}
        />
        <input
          type="text"
          value={linkUrl}
          onChange={e => setLinkUrl(e.target.value)}
          placeholder="Enter link (URL)"
          ref={urlInputRef}
          className="mb-10px p-5px w-100 border rounded-5px border-bottom-ccc"
          onKeyDown={e => {
            if (e.key === 'Enter') {
              onInsert(linkDisplay, linkUrl);
              setLinkDisplay("");
              setLinkUrl("");
            }
          }}
        />
        <div>
          <button className="button-submit-insert" disabled={!isInsertEnabled} onClick={() => {
            onInsert(linkDisplay, linkUrl);
            setLinkDisplay("");
            setLinkUrl("");
          }}>Insert</button>
          <button className="button-submit-cancel" onClick={() => {
            setLinkDisplay("");
            setLinkUrl("");
            onCancel();
          }}>Cancel</button>
        </div>
      </div>
    );
  };

  const Editor = React.forwardRef(({ signature, isSignatureHtml, savedRange, isMaximized }, ref) => {
    const [editorHtml, setEditorHtml] = useState(localStorage.getItem("sendingEmail") || "");
    const [theme] = useState('snow');
    const quillRef = useRef(null);
    const hasAppendedSignatureRef = useRef(false);

    useEffect(() => {
      const appendSignature = async () => {
        const savedSignature = localStorage.getItem("sendingEmail");
        if (!savedSignature && signature && !hasAppendedSignatureRef.current) {
          setEditorHtml(prev => {
            const newContent = isSignatureHtml
              ? prev + `<br><br>${signature}`
              : prev + `<div><br></div><div><br></div><div>${signature}</div>`;

            localStorage.setItem("sendingEmail", signature);
            return newContent;
          });
          hasAppendedSignatureRef.current = true;
          setTimeout(() => {
            const quill = quillRef.current?.getEditor();
            if (quill) {
              quill.focus();
              quill.setSelection(quill.getLength(), 0);
            }
          }, 0);
        }
      };
      appendSignature();
    }, [signature, isSignatureHtml]);

    const handleUndo = () => {
      const quill = quillRef.current.getEditor();
      quill.history.undo();
    };


    const handleRedo = () => {
      const quill = quillRef.current.getEditor();
      quill.history.redo();
    };


    const handleFileChange = async (event) => {
      const newFiles = Array.from(event.target.files);
      const combinedFiles = [...selectedFiles, ...newFiles];
      const maxSize = 25 * 1024 * 1024; // 25 MB in bytes
      const totalSize = combinedFiles.reduce((acc, file) => acc + file.size, 0);
      if (totalSize > maxSize) {
        toast.error("Total file size exceeds the limit of 25 MB.", {
          position: "top-center",
          transition: Bounce,
        });
        return;
      }
      setSelectedFiles(combinedFiles);
    };

    useEffect(() => {
      const getData = async () => {
        const generalSettings = await getGeneralSettings();
        setIsSpellCheck(generalSettings.isSpellChecked ? "true" : "false");
      }
      getData();
    }, []);


    useEffect(() => {
      const editor = document.querySelector('.ql-editor');
      if (editor) {
        editor.setAttribute('spellcheck', isSpellCheck);
      }
    }, [isSpellCheck, editorHtml]);

    const handleEditorContainerMouseDown = (event) => {
      // Allow interactions inside the link popup without stealing focus
      const isInsideLinkPopup = event.target.closest('.text-editor');
      if (isInsideLinkPopup) return;

      const editorRoot = document.querySelector('.ql-editor');
      const clickedInsideEditable = editorRoot && editorRoot.contains(event.target);
      if (!clickedInsideEditable) {
        event.preventDefault();
        const quill = quillRef.current?.getEditor();
        if (quill) quill.focus();
      }
    };


    const handleDragOver = (event) => {
      event.preventDefault();

    };

    const handleRemoveFile = (indexToRemove) => {
      setSelectedFiles(prevFiles => prevFiles.filter((file, index) => index !== indexToRemove));
    }
    const handleFileDrop = (event) => {
      event.preventDefault()
      const files = event.dataTransfer.files;
      if (files) {
        const combinedFiles = [...selectedFiles, ...files];
        const maxSize = 25 * 1024 * 1024; // 25 MB in bytes
        const totalSize = combinedFiles.reduce((acc, file) => acc + file.size, 0);
        if (totalSize > maxSize) {
          toast.error("Total file size exceeds the limit of 25 MB.", {
            position: "top-center",
            transition: Bounce,
          });
          return;
        }
        setSelectedFiles(combinedFiles);
      }
      const text = event.dataTransfer.getData('text/plain');
      const quill = quillRef.current.getEditor();
      const range = quill.getSelection();
      const cursorPosition = range ? range.index : 0;
      quill.focus();
      quill.insertText(cursorPosition, text);
      quill.setSelection(cursorPosition + text.length, 0);
    }

    const handleInsertLink = () => {
      const quill = quillRef.current.getEditor();
      quill.focus();
      if (savedRange.current && typeof savedRange.current.index === 'number') {
        setTimeout(() => {
          quill.setSelection(savedRange.current.index, savedRange.current.length);
          const range = { index: savedRange.current.index, length: savedRange.current.length };
          if (range && linkUrl) {
            if (range.length === 0 && linkDisplay) {
              quill.insertText(range.index, linkDisplay, 'link', linkUrl);
            } else {
              quill.format('link', linkUrl);
            }
            setIsPopupVisible(false);
            setLinkDisplay('');
            setLinkUrl('');
            savedRange.current = null;
          }
        }, 0);
      } else {
        const range = quill.getSelection();
        if (range && linkUrl) {
          if (range.length === 0 && linkDisplay) {
            quill.insertText(range.index, linkDisplay, 'link', linkUrl);
          } else {
            quill.format('link', linkUrl);
          }
          setIsPopupVisible(false);
          setLinkDisplay('');
          setLinkUrl('');
          savedRange.current = null;
        }
      }
    };
    const [isSignatureOpen, setIsSignatureOpen] = useState(false);
    const [signatureSettings, setSignatureSettings] = useState([]);
    const [signatureAccount, setSignatureAccount] = useState("");

    // Fetch signature settings and account for modal
    const fetchSignatureSettings = async () => {
      if (window.ncogProvider) {
        const walletAddress = localStorage.getItem("walletAddress");
        setSignatureAccount(walletAddress);
      }
      const helperContract = await import('../../helper/contract-helper');
      try {
        const contract = helperContract.getHostHelperContract();
        const settings = await contract.methods.getSettings(user.name).call();
        setSignatureSettings(settings);
      } catch (err) {
        console.log(err);
      }
    };

    {/* <ReactQuill theme={theme} spellCheck={true} onChange={setEditorHtml} ref={quillRef} value={editorHtml} modules={{ toolbar: editorConstant.toolBar }} placeholder="Type your message here..."/> */ }
    return (

      <div className={`quil-text-editor${isMaximized ? ' maximized' : ''}`} onDrop={handleFileDrop} onDragOver={handleDragOver} onMouseDown={handleEditorContainerMouseDown}
      >
        <ReactQuill
          theme={theme}
          spellCheck={true}
          onChange={(value) => {
            setEditorHtml(value);
            localStorage.setItem("sendingEmail", value);
          }}
          ref={quillRef}
          value={editorHtml}
          modules={{ toolbar: editorConstant.toolBar }}
          placeholder="Type your message here..."
          preserveWhitespace={true}
        />
        <div className="attachment-file-rendering-method">
          {selectedFiles.length > 0 && (
            <div className="attachment-section-element">
              {selectedFiles.map((file, index) => (
                <a key={index}>{file.name} <span className="delete-icon cursor-pointer" onClick={() => handleRemoveFile(index)}> &#10006;
                </span></a>
              ))}
            </div>
          )}
        </div>
        <div className="div-btn-action-compose-email">
          <div className="compose-emails-actions text-selection">
            <div className="compose-email-bth-operations">

              <div className="delete-functionality cursor-pointer" title="Discard draft" >   <span onClick={() => {
                // Discarded on purpose — scrub the buffer rather than leaving the body (and the
                // recipients, which this never cleared at all) readable on disk.
                clearComposeBuffer();
                dispatch({ type: "IS_COMPOSE", payload: false });
                dispatch({ type: "DRAFT", payload: null });
                props.setIsCompose(false);
              }}>{logo.compose_action_delete}</span> </div>
              <div className="mobile-undo-redu-attachment flex items-center gap-10">
                <div className="undo-redu-functionality" >
                  <div className="undo cursor-pointer" onClick={handleUndo}> {logo.undo_action_compose} </div>
                  <div className="redo cursor-pointer" onClick={handleRedo} > {logo.redo_action_compose} </div>
                </div>
                <div className="add-attachment-functionality">
                  <div className="btn-attachment cursor-pointer" onClick={() => document.getElementById('fileInput').click()}>
                    {logo.attachment_icon}
                    {/* <span className="add-file-component"> add file </span> */}
                  </div>
                  <input
                    type="file"
                    id="fileInput"
                    multiple
                    className="d-none"
                    onChange={handleFileChange}
                  />
                </div>
                <div className="d-flex align-items-center cursor-pointer position-relative">
                  <Link2
                    color="#adb5b6"
                    onMouseDown={() => {
                      const quill = quillRef.current.getEditor();
                      const range = quill.getSelection();
                      if (range) {
                        savedRange.current = { index: range.index, length: range.length };
                      }

                    }}
                    onClick={() => setIsPopupVisible(true)}
                  />
                  <LinkPopup
                    isVisible={isPopupVisible}
                    anchorRef={contactRef}
                    onInsert={(display, url) => {
                      const quill = quillRef.current.getEditor();
                      quill.focus();
                      if (savedRange.current && typeof savedRange.current.index === 'number') {
                        setTimeout(() => {
                          quill.setSelection(savedRange.current.index, savedRange.current.length);
                          const range = { index: savedRange.current.index, length: savedRange.current.length };
                          if (range && url) {
                            if (range.length === 0 && display) {
                              quill.insertText(range.index, display, 'link', url);
                            } else {
                              quill.format('link', url);
                            }
                            setIsPopupVisible(false);
                            savedRange.current = null;
                          }
                        }, 0);
                      } else {
                        const range = quill.getSelection();
                        if (range && url) {
                          if (range.length === 0 && display) {
                            quill.insertText(range.index, display, 'link', url);
                          } else {
                            quill.format('link', url);
                          }
                          setIsPopupVisible(false);
                          savedRange.current = null;
                        }
                      }
                    }}
                    onCancel={() => setIsPopupVisible(false)}
                  />
                </div>
                <Tooltip title="Create event">
                  <div className="btn-event cursor-pointer d-flex align-items-center" onClick={() => {
                    window.dispatchEvent(new Event("NEW_EVENT"));
                  }}>
                    <CalendarIcon />
                  </div>
                </Tooltip>
                {/* <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: '8px' }}>
                  <button
                    className="compose-signature-btn"
                    style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginLeft: '8px' }}
                    onClick={async () => {
                      await fetchSignatureSettings();
                      setIsSignatureOpen(true);
                    }}
                    title="Edit Signature"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#A3ABAD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/></svg>
                  </button>
                </div> */}
                {isSignatureOpen && (
                  <Signature
                    isOpen={isSignatureOpen}
                    close={() => setIsSignatureOpen(false)}
                    loader={setSendLoader}
                    settings={signatureSettings}
                    user={user}
                    account={signatureAccount}
                    onSignatureUpdate={({ signature, isHtml }) => {
                      setSignature(signature || "");
                      setIsSignatureHtml(isHtml);
                    }}
                  />
                )}
              </div>
            </div>
          </div>

          {defaultCC ? <Tooltip title={tooltipText} placement="top" >
            <div className="send-compose-email text-selection" onClick={async () => {
              setSendLoader(true);
              setText("Please wait, your email is being sent, Going forward it will be fast.")
              try {
                // MUST be awaited: composeEmail is async, and without this the catch
                // below never runs for a failed send — the error surfaces as an
                // unhandled rejection and the user sees no "Failed to Send" toast.
                await composeEmail(receiverName);
              } catch (error) {
                const errorStr = toErrorString(error || error.message);
                reportError({
                  endpoint: '/getEncryptValue',
                  message: `FileName: ComposeEmail.js, ${String(error.message || 'Unhandled error')}`,
                  error: errorStr,
                  userName: userName || '',
                });
                setSendLoader(false);
                const notifyMessage = `Failed to Send Message`;
                toast.info(notifyMessage, {
                  position: "top-center",
                  transition: Bounce,
                })
                dispatch({ type: "IS_COMPOSE", payload: false })
                setText("")
                props.setIsCompose(false);
              }
            }}
            >
              <div className="btn-message-compose"> <div> Encrypt and Send </div>
                {/* <div> (Gas 0.005 {config.SYMBOL}) </div>  */}
              </div>
              <div> {logo.compose_svg} </div>
            </div>
          </Tooltip>
            :
            <div className="send-compose-email text-selection" onClick={async () => {
              setSendLoader(true);
              setText("Please wait, your email is being sent, Going forward it will be fast.")
              try {
                // MUST be awaited: composeEmail is async, and without this the catch
                // below never runs for a failed send — the error surfaces as an
                // unhandled rejection and the user sees no "Failed to Send" toast.
                await composeEmail(receiverName);
              } catch (error) {
                const errorStr = toErrorString(error || error.message);
                reportError({
                  endpoint: '/getEncryptValue',
                  message: `FileName: ComposeEmail.js, ${String(error.message || 'Unhandled error')}`,
                  error: errorStr,
                  userName: userName || '',
                });
                setSendLoader(false);
                const notifyMessage = `Failed to Send Message`;
                toast.info(notifyMessage, {
                  position: "top-center",
                  transition: Bounce,
                })
                dispatch({ type: "IS_COMPOSE", payload: false })
                props.setIsCompose(false);
                setText("")
              }
            }}
            >
              <div className="btn-message-compose"> <div> Encrypt and Send </div>
                {/* <div> (Gas 0.005 {config.SYMBOL}) </div>  */}
              </div>
              <div> {logo.compose_svg} </div>
            </div>
          }
        </div>
        {/* <div className="position-abo-messsage">  Message : </div> */}
      </div>
    );
  });

  const appendClassName = (isCC && isBCC) ? "both-carbon copy" : (isCC) ? "carbon" : (isBCC) ? "carbon" : "no-cc-bcc";

  const addToDraft = async () => {

    Swal.fire({
      text: "Are you sure you want to save draft?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#1677ff",
      cancelButtonColor: "#7f7f7f",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      customClass: "compose-sweet-alert",

    }).then(async (result) => {
      if (result.isConfirmed) {
        setSendLoader(true);
        const saved = await saveDraftFunction();
        setSendLoader(false);
        if (!saved) {
          // saveDraftFunction has already told the user why. Do NOT tear the window down: it used to
          // close and blank the buffer regardless of the result, so a draft that failed to save was
          // destroyed in both places right after promising the user it was kept. Leave everything as it
          // is so they can retry or copy the text out.
          return;
        }
        // Saved — the durable copy is now the draft row, sealed under the DEK, so the cleartext buffer
        // has done its job and must not linger.
        clearComposeBuffer();
        dispatch({ type: "COMPOSE_MIN", payload: false });
        dispatch({ type: "DRAFT", payload: null });
        dispatch({ type: "IS_COMPOSE", payload: false })
        props.setIsCompose(false);
        props.reRender();
      } else {
        await closeCompose();
      }
    });
  }

  // Reached when the user answers "No" to "save draft?" — i.e. they explicitly chose not to keep it. The
  // buffer was left behind here, so the body and recipients stayed readable in localStorage after the
  // window closed, and leaked into the NEXT compose opened from quick-access (which, unlike the Navbar
  // button, does not overwrite them).
  const closeCompose = async () => {
    clearComposeBuffer();
    dispatch({ type: "COMPOSE_MIN", payload: false });
    dispatch({ type: "IS_COMPOSE", payload: false })
    dispatch({ type: "DRAFT", payload: null });
    props.setIsCompose(false);
  }

  const [isMaximized, setIsMaximized] = useState(false);
  if (isMinimize) {

    return (
      <div className="minimise-compose-div-element">
        <div className="compose-new-message-txt"> New Message </div>
        <div className="cursor-pointer" >
          <div onClick={() => { dispatch({ type: "COMPOSE_MIN", payload: false }); }} > {logo.compose_max}    </div>
          <div onClick={async () => { addToDraft(); }}  > {logo.compose_close_light}  </div>
        </div>
      </div>
    )
  }
  const isMini = isMinimize ? "minimize-compose" : isMaximized ? "maximized-compose" : "normal-compose";

  const handleInputChange = (value, setValue, fieldType) => {
    setValue(value);
    const parts = value?.split(',') || [];
    const lastEmailPart = parts.length > 1 ? parts[parts.length - 1].trim() : value?.trim() || '';
    if (lastEmailPart) {
      const resValue = emailSuggestions.filter((email) => {
        const response = email.toLowerCase().includes(lastEmailPart.toLowerCase());
        return response;
      })

      setSuggestions(resValue);
    } else {
      setSuggestions([]);
    }
  };

  const handleKeyDown = (e, value, setValue, setClrl, fieldType, ctrl, emailValue, setEmailValue) => {
    setInputType(fieldType);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setHighlightedIndex(prev => (prev + 1) % suggestions.length);
    }

    if (e.key === 'ArrowUp') {
      e.preventDefault();
      setHighlightedIndex(prev => (prev - 1 + suggestions.length) % suggestions.length);
    }

    if (e.ctrlKey && e.key === 'a') {
      e.preventDefault();
      e.target.select();
      setClrl(true)
    }

    if (e.ctrlKey && e.key === 'c') {
      e.preventDefault();
      navigator.clipboard.writeText(value)
        .then(() => console.log('Emails copied to clipboard'))
        .catch((err) => {
          const errorStr = toErrorString(err || err.message);
          reportError({
            endpoint: '-',
            message: `FileName: ComposeEmail.js, Fun: handleKeyDown, ${String(err.message || 'Unhandled error')}`,
            error: errorStr,
            userName: userName || '',
            level: 'warn',
          });
          console.error('Failed to copy emails: ', err)
        });
    }

    if (e.ctrlKey && e.key === 'v') {
      e.preventDefault();
      navigator.clipboard.readText()
        .then((clipboardText) => {
          const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
          const emails = (clipboardText.match(emailRegex) || []).map(email => email.trim().toLowerCase());
          const currentEmails = value ? value.split(',').map(email => email.trim().toLowerCase()) : [];
          const allEmails = [...currentEmails, ...emails];
          const uniqueEmails = [...new Set(allEmails)];
          setValue(uniqueEmails.join(','));
        })
        .catch((err) => {
          const errorStr = toErrorString(err || err.message);
          reportError({
            endpoint: '-',
            message: `FileName: ComposeEmail.js, Fun: handleKeyDown, ${String(err.message || 'Unhandled error')}`,
            error: errorStr,
            userName: userName || '',
            level: 'warn',
          });
          console.error('Failed to read clipboard: ', err);
        })
    }
    if (e.key === 'Enter' || e.key === 'Tab') {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const input = emailValue?.trim() || '';
      let newEmail = '';
      if (!input) return;
      const parts = input.split(',').map(p => p.trim()).filter(Boolean);
      if (suggestions.length > 0) {
        newEmail = suggestions[highlightedIndex];
      } else if (parts.length === 0) return;
      newEmail = parts[parts.length - 1].toLowerCase();
      const remaining = parts.slice(0, -1);
      const currentEmails = value
        ? value.split(',').map(e => e.trim().toLowerCase())
        : [];
      if (currentEmails.includes(newEmail)) {
        if (!toast.isActive("duplicateEmailError")) {
          toast.info(`Email "${newEmail}" is already added.`, {
            toastId: "duplicateEmailError",
            position: "top-center",
          });
        }
      } else if (emailRegex.test(newEmail)) {
        const allEmails = [...currentEmails, newEmail];
        const uniqueEmails = [...new Set(allEmails)];
        setValue(uniqueEmails.join(','));
      }
      else if (!emailRegex.test(newEmail)) {
        if (suggestions.length > 0) {
          const allEmails = [...currentEmails, suggestions[highlightedIndex]];
          const uniqueEmails = [...new Set(allEmails)];
          setValue(uniqueEmails.join(','));
        }
        else {
          if (!toast.isActive("duplicateEmailError")) {
            toast.info(`Please Enter the valid Email.`, {
              toastId: "duplicateEmailError",
              position: "top-center",
            });
          }
          return
        }
      }
      setEmailValue(remaining.join(', '));
      setHighlightedIndex(0);
      setSuggestions([]);
    }

    if (e.ctrlKey && e.key === 'x') {
      e.preventDefault();
      navigator.clipboard.writeText(value)
        .then(() => console.log('Emails cut to clipboard'))
        .catch((err) => {
          const errorStr = toErrorString(err || err.message);
          reportError({
            endpoint: '-',
            message: `FileName: ComposeEmail.js, Fun: handleKeyDown, ${String(err.message || 'Unhandled error')}`,
            error: errorStr,
            userName: userName || '',
            level: 'warn',
          });
          console.error('Failed to cut emails: ', err)
        });
      setValue('');
    }

    if (e.key === "Backspace" && emailValue.length === 0) {
      if (["receiver", "cc", "bcc"].includes(fieldType)) {
        const updatedList = value.split(",").filter(Boolean);
        updatedList.pop();
        setValue(updatedList.join(","));
      }
    }
    if (ctrl && e.key === "Backspace") {
      setValue();
      setClrl(false)
    }
  };

  const handleSuggestionClick = (email, setEmailValue) => {
    if (!email) return
    const regexp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValidEmail = regexp.test(String(email).toLowerCase());
    if (!isValidEmail) {
      if (!toast.isActive("duplicateEmailError")) {
        toast.info(`Please Enter the valid Email.`, {
          toastId: "duplicateEmailError",
          position: "top-center",
        });
      }
      return
    }


    const updateEmails = (existingEmails, setEmails, storageKey, clearInput) => {
      const emailList = existingEmails ? existingEmails.split(',').filter(Boolean) : [];
      if (emailList.includes(email)) {
        if (!toast.isActive("duplicateEmailError")) {
          toast.info("This email is already added.", {
            toastId: "duplicateEmailError",
            position: "top-center",

          });
        }
        return
      }
      emailList.push(email);
      const uniqueEmails = [...new Set(emailList)];
      const emailString = uniqueEmails.join(',') + ',';
      setEmails(emailString);
      localStorage.setItem(storageKey, emailString);
      clearInput("");
    };

    switch (inputType) {
      case 'receiver':
        updateEmails(receiverName, setReceiverName, "recipient", setEmailId);
        break;
      case 'cc':
        updateEmails(CC, setCC, "cc", setEmailCC);
        break;
      case 'bcc':
        updateEmails(BCC, setBCC, "bcc", setEmailBCC);
        break;
      default:
        break;
    }
    setSuggestions([]);
  };

  const handleFocus = (fieldType) => {
    setIsFocused(prevState => ({
      receiver: false,
      cc: false,
      bcc: false,
    }));
    setIsFocused(prevState => ({ ...prevState, [fieldType]: true }));
  };
  const handleTabKey = (e) => {
    const editorContent = document.querySelector('.ql-editor');
    if (e.key === "Tab") {
      if (e.shiftKey) {
      } else {
        e.preventDefault();
        editorContent.focus();
      }

    }
  };

  let draggedItemIndex = null;
  let draggedSource = null;
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const handleDragStart = (e, index, source, value) => {
    draggedItemIndex = index;
    draggedSource = source;
    const response = value && value.split(",").length > 0 ? value.split(",").filter(Boolean) : [];

    e.dataTransfer.setData("text", response[index]);
  };

  const handleDropText = (e, targetIndex, targetSource, setTargetSource) => {
    e.preventDefault();
    let draggedItems = [];
    let setDraggedSource;

    if (draggedSource === "receiver") {
      draggedItems = receiverName.split(",").filter(Boolean);
      setDraggedSource = setReceiverName;
    } else if (draggedSource === "cc") {
      draggedItems = CC.split(",").filter(Boolean);
      setDraggedSource = setCC;
    } else if (draggedSource === "bcc") {
      draggedItems = BCC.split(",").filter(Boolean);
      setDraggedSource = setBCC;
    }

    const [movedItem] = draggedItems.splice(draggedItemIndex, 1);
    setDraggedSource(draggedItems.join(","));

    const targetItems = targetSource.split(",").filter(Boolean);

    if (targetIndex >= 0) {
      targetItems.splice(targetIndex, 0, movedItem);
    } else {
      targetItems.push(movedItem);
    }
    const updatedvalue = [...new Set(targetItems)]
    setTargetSource(updatedvalue.join(","));
    draggedItemIndex = null;
    draggedSource = null;
  };

  const handleDropTexts = (e, targetSource, setTargetSource, inputValue, setInputValue) => {
    e.preventDefault();
    const droppedText = e.dataTransfer.getData("text");
    if (!droppedText) return;
    let draggedItems, setDraggedSource;
    if (draggedSource === "receiver") {
      draggedItems = receiverName.split(",");
      setDraggedSource = setReceiverName;
    } else if (draggedSource === "cc") {
      draggedItems = CC.split(",");
      setDraggedSource = setCC;
    } else if (draggedSource === "bcc") {
      draggedItems = BCC.split(",");
      setDraggedSource = setBCC;
    }
    const updatedDraggedItems = draggedItems.filter((email) => email !== droppedText);
    setDraggedSource(updatedDraggedItems.join(","));
    const res = targetSource ? targetSource.split(",").filter(Boolean) : []
    const updatedTargetItems = [...new Set([...res, droppedText])];
    setTargetSource(updatedTargetItems.join(","));
    draggedItemIndex = null;
    draggedSource = null;
  };

  const renderSuggestion = () => {
    const parts = emailCC?.split(",").map(p => p.trim()).filter(Boolean) || [];
    const lastPart = parts[parts.length - 1];

    const isSelected = receiverName
      ? receiverName.split(",").map(e => e.trim()).includes(lastPart)
      : false;

    const emailValue = BCC
      ? BCC.split(",").map(e => e.trim()).includes(lastPart)
      : false;

    const emailCCValue = CC
      ? CC.split(",").map(e => e.trim()).includes(lastPart)
      : false;

    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(lastPart);

    if (lastPart && isValid && !isSelected && !emailValue && !emailCCValue) {
      return (
        <div className="suggestion-list" ref={suggestionListRef}>
          <div className="suggestion-body">
            <div
              className="suggestion-list-email"
              key={lastPart}
              onClick={(e) => {
                e.stopPropagation();
                handleSuggestionClick(lastPart, setCC);
              }}
            >
              <div className="user-profile-pic">
                {lastPart.charAt(0).toUpperCase()}
              </div>
              <div>{lastPart}</div>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };
  const renderSuggestions = () => {
    const parts = emailBCC?.split(",").map(p => p.trim()).filter(Boolean) || [];
    const lastPart = parts[parts.length - 1];

    const isSelected = receiverName
      ? receiverName.split(",").map(e => e.trim()).includes(lastPart)
      : false;

    const emailValue = BCC
      ? BCC.split(",").map(e => e.trim()).includes(lastPart)
      : false;

    const emailCCValue = CC
      ? CC.split(",").map(e => e.trim()).includes(lastPart)
      : false;

    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(lastPart);

    if (lastPart && isValid && !isSelected && !emailValue && !emailCCValue) {
      return (
        <div className="suggestion-list" ref={suggestionListRef}>
          <div className="suggestion-body">
            <div
              className="suggestion-list-email"
              key={lastPart}
              onClick={(e) => {
                e.stopPropagation();
                handleSuggestionClick(lastPart, setBCC);
              }}
            >
              <div className="user-profile-pic">
                {lastPart.charAt(0).toUpperCase()}
              </div>
              <div>{lastPart}</div>
            </div>
          </div>
        </div>
      );
    }

    return null;
  };
  const handleDelete = (e, index, setValue, receiverName) => {
    e.preventDefault();
    const nameArray = receiverName.split(",");
    if (index >= 0 && index < nameArray.length) {
      nameArray.splice(index, 1);
    }
    setValue(nameArray.join(","));
  };
  const handleClick = (e, index, value, setValue, setResponse, emailvalue) => {
    e.stopPropagation();
    let updatedReceiverNames = value.split(',').filter(Boolean);
    if (emailvalue) {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (regex.test(emailvalue)) {
        updatedReceiverNames.push(emailvalue);
      }
    }
    updatedReceiverNames = [...new Set(updatedReceiverNames)];
    setValue(updatedReceiverNames[index]);
    updatedReceiverNames.splice(index, 1);
    setResponse(updatedReceiverNames.join(','));
  };

  const handleContact = (value) => {
    setRecipientType(value)
    setContact(!contact)
  }
  const handleTabFocus = (e) => {
    if (e.key !== "Tab") return;
    e.preventDefault();
    if (emailId || emailCC || emailBCC) {
      return
    }

    if (suggestions && suggestionListRef.current) return;
    if (e.shiftKey) {
      if (document.activeElement === receiverRef.current) {
        receiverRef.current?.blur();
      }
      else if (document.activeElement === ccRef.current) {
        receiverRef.current?.focus();
      } else if (document.activeElement === bccRef.current) {
        if (isCC) {
          ccRef.current?.focus();
        } else {
          receiverRef.current?.focus();
        }
      }


    } else {
      if (document.activeElement === receiverRef.current && isCC) {
        ccRef.current?.focus();
      }
      else if (document.activeElement === receiverRef.current && (!isBCC && !isCC)) {
        topicRef.current?.focus();
      }
      else if (document.activeElement === ccRef.current && (!isBCC)) {
        topicRef.current?.focus();
      }
      else if (document.activeElement === bccRef.current) {
        topicRef.current?.focus();
      }
      else if (document.activeElement === receiverRef.current && isBCC && !isCC) {
        bccRef.current?.focus();
      } else if (document.activeElement === ccRef.current && isBCC) {
        bccRef.current?.focus();
      }

    }
  };

  return (

    <div className={'message-box-position ' + appendClassName + " " + isMini} >
      <div className='compose-email-send' id="compose-email-send" >
        <div className='header-compose-email'>
          <span> New Message</span>
          <div className="cursor-pointer flex items-center gap-10" >
            <div className="h-100" onClick={() => { dispatch({ type: "COMPOSE_MIN", payload: true }); }} > {logo.compose_mini}    </div>
            <div className="h-100" onClick={() => setIsMaximized(!isMaximized)} title={isMaximized ? "Restore Down" : "Maximize"}>
              {isMaximized ? (logo.compose_restore || <span className="fs-18px">🗗</span>) : (<span className="fs-6">🗖</span>)}
            </div>
            {/* <Popconfirm title="Are you sure you want to save draft?" onConfirm={addToDraft} onCancel={closeCompose} okText="Yes" cancelText="No"> */}
            <div className="flex items-center h-100 close-compose" onClick={() => addToDraft()}>{logo.compose_close}</div>
            {/* </Popconfirm> */}
          </div>
        </div>

        <div className={`${isMaximized ? 'input-compose-max' : 'input-componse-msg'}`}>
          <div className='send-alert-body-content connect-wallet-account-div reply-email-user'>
            <div onKeyDown={(e) => { handleTabFocus(e) }}>


              <div className="email-username reply-user compose">
                {/* <span>To</span> */}
                {
                  sendAsEmail?.length ?
                    <select className="from-user-select compose" id={"sender"} value={fromAddress} onChange={(e) => { console.log("e?.target?.value", e?.target?.value); setFromAddress(e?.target?.value) }} >
                      {sendAsEmail?.map((data, index) => {
                        return (
                          <option key={index} defaultValue={() => {
                            if (data.isDefault === 'true' || data.isDefault === true) {
                              return data.email
                            }
                          }} value={data.email}>{data.email}</option>
                        )
                      })}
                    </select>
                    : <input className="reply-user-input compose" placeholder="Sender" id={"sender"} defaultValue={user.name} readOnly={true} />
                }
              </div>
              {defaultCC && (
                <div
                  className="default-cc-element email-username reply-user compose"
                >
                  <Tooltip title={tooltipText} placement="top" >
                    <input
                      className="default-cc suggestion-input compose"
                      value={defaultCC}
                      placeholder="CC"
                      disabled
                    />
                  </Tooltip>
                </div>
              )}
              <div className="dragValue" >
                <div className="mailContent w-[100%]">
                  <ul className={ctrlA ? "maindiv hoverColor" : "maindiv"}>
                    <span className="title" onClick={() => handleContact("to")}> <Tooltip title="Select Contacts">TO</Tooltip></span>
                    {receiverName && receiverName.split(",").length > 0 ? receiverName.split(",").filter(name => name !== "").map((data, index) => {
                      const emailValue = data.trim();
                      return (<li key={index} className="receiverEmails  w-[100%] list-unstyled m-5px cursor-pointer text-decoration-none" draggable
                        onDragStart={(e) => handleDragStart(e, index, "receiver", receiverName)}
                        onDragOver={handleDragOver}
                        onDrop={(e) => handleDropText(e, index, receiverName, setReceiverName)}
                        onClick={(e) => {
                          setInputType('receiver');
                          handleClick(e, index, receiverName, setEmailId, setReceiverName, emailId)
                        }}
                      >
                        <div className="mainDiv">
                          <p className="receiverPhoto">{emailValue[0] ? emailValue[0].toUpperCase() : emailValue[1].toUpperCase}</p>
                          <p className="emailValue">{emailValue}</p>
                          <p className="close_icon ms-5px" onClick={(e) => {
                            e.stopPropagation();
                            handleDelete(e, index, setReceiverName, receiverName)
                          }}> {logo.compose_close}</p>
                        </div>
                      </li>)
                    }
                    )
                      : null}
                    <div className="email-username reply-user compose d-flex align-items-center flex-fill border-0 p-0 min-w-150px position-relative ml-4" ref={toemailId}>

                      <input
                        className="reply-user-input suggestion-input compose ps-10px"
                        id={"receiver"}
                        value={emailId}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => {
                          handleDropTexts(e, receiverName, setReceiverName, emailId, setEmailId)
                        }}
                        onClick={() => {
                          setInputType('receiver');
                          setToSuggestion(true);
                          setHighlightedIndex(0);
                        }}
                        ref={receiverRef}
                        onKeyDown={(e) => handleKeyDown(e, receiverName, setReceiverName, setCtrlA, 'receiver', ctrlA, emailId, setEmailId)}
                        onChange={(e) => { localStorage.setItem("recipient", e.target.value); handleInputChange(e.target.value, setEmailId, 'receiver') }}
                        onFocus={() => {
                          setToSuggestion(true);
                          setCCSuggestion(false);
                          setBCCSuggestion(false);
                          handleFocus('receiver')
                        }}
                        autoComplete="off"
                      />
                      {!accountSettings.isSecureSent &&
                        <div className="d-flex align-items-center">
                          <span className="compose-cc-bcc" onClick={() => setIsCC(!isCC)}> CC </span>
                          <span className="compose-cc-bcc" onClick={() => setIsBCC(!isBCC)}> BCC </span>
                        </div>
                      }
                      {
                        !ctrlA &&
                        emailId &&
                        suggestions.length === 0 &&
                        tosuggestion &&
                        (() => {
                          const parts = emailId.split(',').map(p => p.trim()).filter(Boolean);
                          const lastPart = parts[parts.length - 1];

                          if (!lastPart || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(lastPart)) {
                            return null;
                          }

                          return (
                            <div className="suggestion-list">
                              <div className="suggestion-body">
                                <div
                                  className="suggestion-list-email"
                                  key={lastPart}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSuggestionClick(lastPart, setReceiverName);
                                  }}
                                >
                                  <div className="user-profile-pic">
                                    {lastPart.charAt(0).toUpperCase()}
                                  </div>
                                  <div>{lastPart}</div>
                                </div>
                              </div>
                            </div>
                          );
                        })()
                      }

                      {isFocused.receiver && suggestions.length > 0 && tosuggestion && (
                        <div className="suggestion-list" ref={suggestionListRef}>
                          <div className="suggestion-body" >
                            {suggestions.map((email, index) => {
                              const isSelected = receiverName
                                ? receiverName.split(",").filter(Boolean).includes(email) : false;
                              const emailValue = CC ? CC.split(",").filter(Boolean).includes(email) : false;
                              const isHighlighted = index === highlightedIndex;
                              const suggestionClass = `suggestion-list-email ${isHighlighted ? 'highlighted' : ''}`;
                              if (!isSelected && !emailValue) {
                                return (
                                  <div
                                    className={`suggestion-list-email ${suggestionClass}`}
                                    key={email} // Use email as the key for uniqueness
                                    ref={(el) => itemRefs.current[index] = el}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleSuggestionClick(email, setReceiverName);
                                      setHighlightedIndex(0)
                                    }}
                                  >
                                    <div className="user-profile-pic">{email.charAt(0).toUpperCase()}</div>
                                    <div>{email}</div>
                                  </div>
                                );
                              }
                              else {
                                return (
                                  <div
                                    className="suggestion-list-email pointer-none opacity-50"
                                    key={email} // Use email as the key for uniqueness
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      handleSuggestionClick(email, setReceiverName)
                                    }}
                                  >
                                    <div className="user-profile-pic">{email.charAt(0).toUpperCase()}</div>
                                    <div>{email}</div>
                                  </div>
                                );
                              }
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  </ul>
                </div>
              </div>
              {!accountSettings.isSecureSent && isCC && (
                <div className="dragValue" >
                  <div className="mailContent">
                    <ul className={ctrlCC ? "maindiv hoverColor" : "maindiv"}>
                      <span className="title" onClick={() => handleContact("cc")}> <Tooltip title="Select Contacts">CC</Tooltip></span>
                      {CC && CC.split(",").length > 0 ? CC.split(",").filter(name => name !== "").map((data, index) =>
                        <li key={index} className="receiverEmails text-decoration-none list-unstyled m-1 cursor-pointer" draggable
                          onDragStart={(e) => handleDragStart(e, index, "cc", CC)}
                          onDragOver={handleDragOver}
                          onDrop={(e) => handleDropText(e, index, CC, setCC)}
                          onClick={(e) => {
                            setInputType('cc');
                            handleClick(e, index, CC, setEmailCC, setCC, emailCC)
                          }}
                        >
                          <div className="mainDiv">
                            <p className="receiverPhoto">{data[0]?.toUpperCase()}</p>
                            <p >{data}</p>
                            <p className="close_icon ms-5px" onClick={(e) => {
                              e.stopPropagation();
                              handleDelete(e, index, setCC, CC);
                            }}> {logo.compose_close}</p>
                          </div>
                        </li>
                      )
                        : null}
                      <div className="email-username reply-user compose d-flex align-items-center flex-grow-1 border-0 p-0 position-relative min-w-150px" ref={ccemailId}>
                        <input
                          className="reply-user-input suggestion-input compose ps-10px"
                          value={emailCC}
                          onClick={() => {
                            setInputType('cc');
                            setCCSuggestion(true);
                            setHighlightedIndex(0)
                          }}
                          onChange={(e) => { localStorage.setItem("cc", e.target.value); handleInputChange(e.target.value, setEmailCC, 'cc') }}
                          onFocus={() => {
                            setToSuggestion(false);
                            setCCSuggestion(true);
                            setBCCSuggestion(false)
                            handleFocus('cc')
                          }}
                          onKeyDown={(e) => handleKeyDown(e, CC, setCC, setCtrlCC, 'cc', ctrlCC, emailCC, setEmailCC)}
                          autoComplete="off"
                          onDragOver={(e) => e.preventDefault()}
                          ref={ccRef}
                          onDrop={(e) => {
                            handleDropTexts(e, CC, setCC, emailCC, setEmailCC)
                          }}
                        />
                        {!ctrlCC && emailCC && suggestions.length === 0 && ccsuggestion && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailCC) && renderSuggestion()}

                        {isFocused.cc && suggestions.length > 0 && ccsuggestion && (
                          <div className="suggestion-list" >
                            <div className="suggestion-body">
                              {suggestions.map((email, index) => {
                                const isSelected = receiverName
                                  ? receiverName.split(",").filter(Boolean).includes(email) : false;
                                const emailValue = CC ? CC.split(",").filter(Boolean).includes(email) : false;
                                const isHighlighted = index === highlightedIndex;
                                const suggestionClass = `suggestion-list-email ${isHighlighted ? 'highlighted' : ''}`;
                                if (!isSelected && !emailValue && !BCC) {
                                  return (
                                    <div
                                      className={`suggestion-list-email ${suggestionClass}`}
                                      key={email}
                                      ref={(el) => itemRefs.current[index] = el}
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        handleSuggestionClick(email, setReceiverName)
                                        setHighlightedIndex(0)
                                      }}
                                    >
                                      <div className="user-profile-pic">{email.charAt(0).toUpperCase()}</div>
                                      <div>{email}</div>
                                    </div>
                                  );
                                }
                                else {
                                  return (
                                    <div
                                      className="opacity-50 disabled-pointer suggestion-list-email"
                                      key={email}
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        handleSuggestionClick(email, setReceiverName)
                                      }}
                                    >
                                      <div className="user-profile-pic">{email.charAt(0).toUpperCase()}</div>
                                      <div>{email}</div>
                                    </div>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    </ul>
                  </div>
                </div>
              )}
              {!accountSettings.isSecureSent && isBCC && (
                <div className="dragValue"  >
                  <div className="mailContent">
                    <ul className={ctrlBCC ? "maindiv hoverColor" : "maindiv"}>
                      <span className="title" onClick={() => handleContact("bcc")}><Tooltip title="Select Contacts">BCC</Tooltip></span>
                      {BCC && BCC.split(",").length > 0 ? BCC.split(",").filter(name => name !== "").map((data, index) =>
                        <li key={index} className="receiverEmails text-decoration-none list-unstyled m-1 cursor-pointer" draggable
                          onDragStart={(e) => handleDragStart(e, index, "bcc", BCC)}
                          onDragOver={handleDragOver}
                          onDrop={(e) => handleDropText(e, index, BCC, setBCC)}
                          onClick={(e) => {
                            setInputType('bcc');
                            handleClick(e, index, BCC, setEmailBCC, setBCC, emailBCC)
                          }} >
                          <div className="mainDiv">
                            <p className="receiverPhoto">{data[0]?.toUpperCase()}</p>
                            <p >{data}</p>
                            <p className="close_icon ms-5px" onClick={(e) => {
                              e.stopPropagation()
                              handleDelete(e, index, setBCC, BCC)
                            }}> {logo.compose_close}</p>
                          </div>
                        </li>
                      )
                        : null}
                      <div className="email-username reply-user compose d-flex align-items-center flex-grow-1 border-0 p-0 position-relative min-w-150px" ref={bccemailId}>
                        <input
                          // placeholder="BCC"
                          className="reply-user-input suggestion-input compose ps-10px"
                          value={emailBCC}
                          onClick={() => {
                            setBCCSuggestion(true)
                            setInputType('bcc');
                            setHighlightedIndex(0)
                          }}
                          onChange={(e) => { localStorage.setItem("bcc", e.target.value); handleInputChange(e.target.value, setEmailBCC, 'bcc') }}
                          onFocus={() => {
                            setToSuggestion(false);
                            setCCSuggestion(false);
                            setBCCSuggestion(true)
                            handleFocus('bcc')
                          }}
                          onKeyDown={(e) => handleKeyDown(e, BCC, setBCC, setCtrlBCC, 'bcc', ctrlBCC, emailBCC, setEmailBCC)}
                          onDragOver={(e) => e.preventDefault()}
                          ref={bccRef}
                          onDrop={(e) => {
                            handleDropTexts(e, BCC, setBCC, emailBCC, setEmailBCC)
                          }}
                          autoComplete="off"
                        />
                        {!ctrlBCC && emailBCC && suggestions.length === 0 && bccsuggestion && /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailBCC) && renderSuggestions()}

                        {isFocused.bcc && suggestions.length > 0 && bccsuggestion && (
                          <div className="suggestion-list" >
                            <div className="suggestion-body">
                              {suggestions.map((email, index) => {
                                const isSelected = receiverName
                                  ? receiverName.split(",").filter(Boolean).includes(email) : false;

                                const emailValue = receiverName ? receiverName.split(",").filter(Boolean).includes(email) : false;
                                const emailBCCValue = BCC ? BCC.split(",").filter(Boolean).includes(email) : false;
                                const isHighlighted = index === highlightedIndex;
                                const suggestionClass = `suggestion-list-email ${isHighlighted ? 'highlighted' : ''}`;
                                if (!isSelected && !emailValue && !emailBCCValue) {
                                  return (
                                    <div
                                      className={`suggestion-list-email ${suggestionClass}`}
                                      key={email}
                                      ref={(el) => itemRefs.current[index] = el}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleSuggestionClick(email, setReceiverName);
                                        setHighlightedIndex(0)
                                      }}
                                    >
                                      <div className="user-profile-pic">{email.charAt(0).toUpperCase()}</div>
                                      <div>{email}</div>
                                    </div>
                                  );
                                }
                                else {
                                  return (
                                    <div
                                      className="opacity-50 disabled-pointer suggestion-list-email"
                                      key={email} // Use email as the key for uniqueness
                                      onClick={(e) => {
                                        e.stopPropagation()
                                        handleSuggestionClick(email, setEmailBCC)
                                      }}
                                    >
                                      <div className="user-profile-pic">{email.charAt(0).toUpperCase()}</div>
                                      <div>{email}</div>
                                    </div>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        )}
                      </div>
                    </ul>
                  </div>
                </div>
              )} </div>

            <div className="email-username reply-user compose topic" >
              {/* <span>Topic:</span> */}
              <input
                className="reply-user-input"
                id={"subject"}
                placeholder="Topic"
                value={subject}
                onKeyDown={handleTabKey}
                onFocus={() => {
                  setSuggestions([])
                }}
                ref={topicRef}
                onChange={(e) => { localStorage.setItem("topic", e.target.value); setSubject(e.target.value) }}
              />
            </div>
          </div>
          <Editor signature={signature} isSignatureHtml={isSignatureHtml} savedRange={savedRange} isMaximized={isMaximized} />
        </div>
        {sendLoader &&
          <CompleteLoader isOpen={sendLoader} text={text} />
        }
      </div>
      {contact && <Contact close={handleContact} userName={user.name} type={recipienttype} to={setReceiverName} cc={setCC} bcc={setBCC} torecipent={receiverName} ccrecipent={CC} bccrecipent={BCC} loader={setSendLoader} />}
    </div >
  )
}

export default ComposeEmail




